// src/lib/firebase.js
import { initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  browserSessionPersistence,
  getAuth,
  setPersistence,
} from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyD7SVCOOEFnZczw7pfZash_1PCFTN77XCw",
  authDomain: "interior-c3a8f.firebaseapp.com",
  databaseURL: "https://interior-c3a8f-default-rtdb.firebaseio.com/",
  projectId: "interior-c3a8f",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);

export const authReady = (async () => {
  try {
    await setPersistence(auth, browserLocalPersistence);
  } catch (localError) {
    console.warn("Local auth persistence unavailable, falling back to session persistence.", localError);
    try {
      await setPersistence(auth, browserSessionPersistence);
    } catch (sessionError) {
      console.warn("Session auth persistence unavailable, using in-memory auth state.", sessionError);
    }
  }
})();
